export const ROWS_PER_PAGE: number = 25;